import { illustrations } from '../../assets/illustrations';

const DEFAULT_PRIMARY_LABEL = 'Collecting data...';

export interface WidgetCollectingStateProps {
  /** Widget title used in the "X will appear here once data is available." sentence. */
  title: string;
  /** Override illustration URL. Falls back to the shared widget empty-state asset. */
  illustration?: string;
  /**
   * Compact horizontal layout — illustration on the left, text on the right.
   * Use inside metric-variant widgets where vertical space is tight.
   */
  compact?: boolean;
  /** Override the primary label. Defaults to "Collecting data...". */
  primaryLabel?: string;
}

export function WidgetCollectingState({
  title,
  illustration,
  compact = false,
  primaryLabel = DEFAULT_PRIMARY_LABEL,
}: WidgetCollectingStateProps) {
  const src = illustration ?? illustrations.chartBarsSun;

  if (compact) {
    return (
      <div className="flex flex-wrap items-center justify-center gap-3">
        <img src={src} alt="" aria-hidden="true" className="h-[80px] w-[96px] shrink-0" />
        <div className="flex min-w-[160px] max-w-[240px] flex-col gap-1 text-center">
          <p className="text-[13px] leading-[1.3] text-grey-400">{primaryLabel}</p>
          <p className="text-[13px] leading-[1.3] text-grey-400">
            {title} will appear here once data is available.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-2 py-6 text-center">
      <img src={src} alt="" aria-hidden="true" className="h-[120px] w-[140px]" />
      <p className="text-[13px] leading-[1.3] text-grey-400">{primaryLabel}</p>
      <p className="max-w-[220px] text-[13px] leading-[1.3] text-grey-400">
        {title} will appear here once data is available.
      </p>
    </div>
  );
}

WidgetCollectingState.displayName = 'WidgetCollectingState';
